import React from "react";

const StarRating = ({ value = 0, onUpdate, theme, className = "" }) => {
	const starImg =
		"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAN9JREFUOI2dlKEOwkAQRN8SBAJxAlGBQCD4/y9BViAQFQgEogLRZBC9wrV3sKWTNGkusy+zt5sDR5KCpI3nW3kG4BC/5SBJOyAAlZfKS3RM/k+LQJIqIE0RJIVvfpsUB2BL304A1hP/E3gALfAws3YEknQCql/Rf6gxs8vQWgN0CyAtcIV4RzHi+U9IB9Rm1r1BCaz+A3RO72g0NTO70bfp6ZJCMlAS2VPmKYG2M0DZlpdA090pKfOUioazDrjTj3cN7PnsWpa6BNrE4mYYbVQt6Ur/ErjPCpLc1uZ4FusFVFlCi4JE3aoAAAAASUVORK5CYII=";
	const starImgActive =
		"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAATNJREFUOI2Vkb1KA2EQRc/sJmCjCFrEHwTBVBKN5AUEV63TqPgEIqh5BwVBsNEX0dak8AF0FRshEWJhkUYUJJ3utdG4u+4uye2++c7cO8NAhtRcWZWPl8Xksj6RnRIAsJCGOOnp3jZGCaOkWzYHMpAqedDJX4FjCbf/CVqju2BTvbcxi89OEmpqLxf4csvIygQsgcqYzfXMPxq/bIB4wrhD3GPck8M3Nb0zYC9tx5BBwq6cOxQbNVA9nUptrlOh5pgRMOJWgccB2h/IUzUjcACscNXFPteQOn0kdxhi3RbpQugKVrx+AY5ieJBgcWjz9IKiZ3RsPAYnnXksHZAmUgYPK8LEEyZjhq/AW6RmFDIm+DEQbWCf4fcZxDTiAHiOMElS07tUy9uQ/u8u4cpnSzdchOvfo9th1r4S7woAAAAASUVORK5CYII=";
	const starImgDark =
		"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAANFJREFUOI2lk6EOwjAQhj9WxMRCJhCEICYQe/8HQSEQExNIQhATC5lA9MZKW9pS/qTper37cr27KeKqZZ9CTkUCqJEVVAy0lYx2QPkP6Gh8t7kgO4uapV6OVta5BiojaG3dj8ADGIz9A9RKBjm6Al1hHILt/aIB6AGUGJ7AHdj/AJmAM/q5b9AMG9EtT9EJo0bKuhzQBd5EIB1wMw2+9qfUyvHxgaoEkDPlPpA9Oz45Pr6g2Tah69CL7cAya07WPlApwfZsXcTeEPmBQ/Acnzy9AE4NIivVF5cRAAAAAElFTkSuQmCC";
	const renderStars = (rating) => {
		return [...Array(5)].map((a, i) => {
			const isActive = rating >= i + 1;
			const val = rating - i;
			const remains = val >= 1 ? 1 : val % 1;
			return (
				<div
					key={i}
					className={`star ${isActive ? "active" : ""} ${onUpdate ? "" : "disabled"}`}
					onClick={() => addStar(i + 1)}>
					<img src={theme === "dark" ? starImgDark : starImg} alt="star inactive" />
					<img
						src={starImgActive}
						alt="star active"
						className="active-image"
						style={{ width: remains * 16 + "px" }}
					/>
				</div>
			);
		});
	};

	const addStar = (event) => {
		if (onUpdate) {
			onUpdate(value / 2 === event ? 0 : event);
		}
		return null;
	};

	const rating = value ? Number(value) / 2 : 0;
	return (
		<div className={`star-rating-wrap ${className}`}>
			<div className="star-rating-container" data-title={`${rating} star${rating > 1 ? "s" : ""}`}>
				{renderStars(rating)}
			</div>
		</div>
	);
};

export default StarRating;
